import { useQuery } from "@apollo/client/react";
import { GET_ITEM_GROUPS, GET_ALL_ITEMS } from "../../containers/Parameters/queries"
import { ItemGroupsResponse, ItemsResponse } from "../../containers/Parameters/types"

export const useItemGroups = () => {
   const query = useQuery<ItemGroupsResponse>(GET_ITEM_GROUPS, {
    fetchPolicy: 'cache-first',
  })

  const itemGroups = query.data && query.data.itemGroups.__typename === 'ItemGroupsSuccess' ? query.data.itemGroups.itemGroups : []
  return { ...query, itemGroups }
}

export const useItems = () => {
 const query = useQuery<ItemsResponse>(GET_ALL_ITEMS, {
  fetchPolicy: 'cache-first',
  })

  const items = query.data && query.data.items.__typename === 'ItemsSuccess' ? query.data.items.items : []
  return { ...query, items }
}